import styled from "styled-components";


export const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
`;

export const MailTokenListContainer = styled.section`
   width: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: ${(props) => props.marginTop ?? "0px"};
  box-shadow: ${(props) => props.boxShadow ?? "2px 4px 4px 0 rgb(0 0 0 / 25%)"};
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  .table-container {
    padding: 0 30px;
  }
`;
